import { render, staticRenderFns } from "./payAli.vue?vue&type=template&id=51dff034&scoped=true&"
import script from "./payAli.vue?vue&type=script&lang=js&"
export * from "./payAli.vue?vue&type=script&lang=js&"
import style0 from "./payAli.vue?vue&type=style&index=0&id=51dff034&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dff034",
  null
  
)

component.options.__file = "payAli.vue"
export default component.exports